import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type PageShellBodyMode = 'scroll' | 'fill';

interface PageShellProps {
  header?: ReactNode;
  children: ReactNode;
  /**
   * `scroll` (default): the body scrolls as one block.
   * `fill`: the body is a flex column that gives its children full height;
   * the child owns its overflow (used by data-table pages).
   */
  bodyMode?: PageShellBodyMode;
  className?: string;
  bodyClassName?: string;
}

export function PageShell({
  header,
  children,
  bodyMode = 'scroll',
  className,
  bodyClassName,
}: PageShellProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 p-4 sm:gap-6 sm:p-6',
        'h-[calc(100dvh-4rem)] overflow-hidden',
        className,
      )}
    >
      {header && <div className="shrink-0">{header}</div>}
      <div
        className={cn(
          'flex-1 min-h-0',
          bodyMode === 'scroll' && 'overflow-y-auto',
          bodyMode === 'fill' && 'flex flex-col',
          bodyClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
